import { render } from "./PhotoTabletFormComponentDetails.vue?vue&type=template&id=679fec7e"
import script from "./PhotoTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./PhotoTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__